import script from "./ManagementChoices.vue?vue&type=script&setup=true&lang=ts"
export * from "./ManagementChoices.vue?vue&type=script&setup=true&lang=ts"

import "./ManagementChoices.vue?vue&type=style&index=0&id=dd53faf2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dd53faf2"]])

export default __exports__